import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  errorCode: null,
  getPractitionerList: [],
  physicalExaminationList: {},
  diagnosticImagingList: {},
  planList: {},
  isstartVoiceRecorder: false,
  isListening: false,
  revaiResponse: '',
  revaiPartialResponse: '',
  physicalExamListening: false,
  physicalExamRevAiResponse: '',
  physicalExamRevAiPartialResponse: '',
  diagnosticsListening: false,
  diagnosticsRevAiResponse: '',
  diagnosticsRevAiPartialResponse: '',
  assessmentListening: false,
  assessmentRevAiResponse: '',
  assessmentRevAiPartialResponse: '',
};

const careConnectSlice = createSlice({
  name: 'careConnectSlice',
  initialState,
  reducers: {
    careConnectLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    getAllPractitionerSlice: (state, { payload }) => {
      state.getPractitionerList = payload;
    },
    physicalExaminationSlice: (state, { payload }) => {
      state.physicalExaminationList = payload;
    },
    diagnosticImagingSlice: (state, { payload }) => {
      state.diagnosticImagingList = payload;
    },
    planSlice: (state, { payload }) => {
      state.planList = payload;
    },
    startVoiceRecorder: (state, { payload }) => {
      state.isstartVoiceRecorder = payload;
    },
    startListening: (state, { payload }) => {
      state.isListening = payload;
    },
    revaiResponse: (state, { payload }) => {
      state.revaiResponse = payload;
    },
    revaiPartialResponse: (state, { payload }) => {
      state.revaiPartialResponse = payload;
    },
    startPhysicalExamListening: (state, { payload }) => {
      state.physicalExamListening = payload;
    },
    physicalExamRevAiResponseSlice: (state, { payload }) => {
      state.physicalExamRevAiResponse = payload;
    },
    physicalExamRevAiPartialResponseSlice: (state, { payload }) => {
      state.physicalExamRevAiPartialResponse = payload;
    },
    startDiagnosticsListening: (state, { payload }) => {
      state.diagnosticsListening = payload;
    },
    diagnosticsRevAiResponseSlice: (state, { payload }) => {
      state.diagnosticsRevAiResponse = payload;
    },
    diagnosticsRevAiPartialResponseSlice: (state, { payload }) => {
      state.diagnosticsRevAiPartialResponse = payload;
    },
    startAssessmentPlanListening: (state, { payload }) => {
      state.assessmentListening = payload;
    },
    assessmentRevAiResponseSlice: (state, { payload }) => {
      state.assessmentRevAiResponse = payload;
    },
    assessmentRevAiPartialResponseSlice: (state, { payload }) => {
      state.assessmentRevAiPartialResponse = payload;
    },
  },
});

const { actions, reducer } = careConnectSlice;

export const {
  careConnectLoading,
  getAllPractitionerSlice,
  physicalExaminationSlice,
  diagnosticImagingSlice,
  planSlice,
  startVoiceRecorder,
  startListening,
  revaiResponse,
  revaiPartialResponse,
  startPhysicalExamListening,
  physicalExamRevAiResponseSlice,
  physicalExamRevAiPartialResponseSlice,
  startDiagnosticsListening,
  diagnosticsRevAiResponseSlice,
  diagnosticsRevAiPartialResponseSlice,
  startAssessmentPlanListening,
  assessmentRevAiResponseSlice,
  assessmentRevAiPartialResponseSlice,
} = actions;

export default reducer;
